import { Component } from 'react'
import URLParser from '../../helpers/url-parser.helper'

export interface SearchOptions {
  search: Record<any, any>,
  options: {
    page?: number,
    limit?: number,
    _force_ids?: boolean,
    sort?: string[]
  }
}

export default class TableHelper<T> extends Component<T> {

  searchOptions: SearchOptions = {
    search: {},
    options: {
      page: 1,
      limit: 999,
      _force_ids: false,
      sort: []
    }
  }

  constructor(props) {
    super(props)

    const params = new URL(document.location as any)
    if (params?.searchParams) {
      const currentPage = params.searchParams.get('page') || 1
      this.searchOptions.options.page = Number(currentPage)
    }
  }

  /**
   * Generic table change props and dispatch
   * 
   */
  handleTableChange = (pagination: any, sorter?: any, dispatch?: any) => {
    const { history }: any = this.props

    let newUrlParams: any[] = []

    if (pagination && Object.keys(pagination).length > 0) {
      const { current, pageSize } = pagination

      this.searchOptions.options.page = current
      this.searchOptions.options.limit = pageSize

      newUrlParams.push({
        key: 'page',
        value: current
      })
    }

    if (sorter && Object.keys(sorter).length > 0) {
      const { columnKey, order } = sorter

      this.searchOptions.options.sort = [
        `${order === 'descend' ? '-' : ''}${columnKey}`
      ]
    }

    // Update browser history
    if (history) {
      URLParser.setParams(history, newUrlParams)
    }
    dispatch(this.searchOptions)
  }
}
